let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4Ig71")).then(() => parcelRequire('3Z1x3'));